import {Component, Input, OnInit} from '@angular/core';
import {BlockElements, Blocks} from '../../entities/blockElements/block.entity';
import {plainToInstance} from 'class-transformer';

@Component({
  selector: 'app-blocks',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlocksComponent implements OnInit {
  public _blocks: Blocks[] = [];

  constructor() {
  }

  @Input() set blocks(blocks: Blocks[]) {

    const blocksTemp = {
      items: blocks
    };

    const b = plainToInstance(BlockElements, blocksTemp);

    this._blocks = b.items;
  }

  get blocks() {
    return this._blocks;
  }

  ngOnInit(): void {

  }


}
